import { useExperiment } from 'utils/experiments'
import { useIsOnboardingRedesign } from './useIsOnboardingRedesign'

/**
 * Hook to determine if the user should see the V2 onboarding redesign
 */
export const useIsOnboardingRedesignV2 = () => {
  const isOnboardingRedesign = useIsOnboardingRedesign()
  const experimentVariant = useExperiment('onboarding_redesign_v2')

  // Only show V2 if user is in the base redesign AND in the 'new_pages' variant
  return isOnboardingRedesign && experimentVariant === 'new_pages'
}
